import { Action } from '@ngrx/store';

import { Oauth } from './oauth.entity';

export enum OauthActionTypes {
    SetOauth = '[Oauth State] Set',
    UnsetOauth = '[Oauth State] Unset'
}

export class SetOauth implements Action {
    readonly type: OauthActionTypes.SetOauth = OauthActionTypes.SetOauth;
    constructor(public payload: Oauth) {}
}

export class UnsetOauth implements Action {
    readonly type: OauthActionTypes.UnsetOauth = OauthActionTypes.UnsetOauth;
}

export type OauthAction = SetOauth | UnsetOauth;
